import { Questionnaire } from "@/types/questionnaire/models"

export const createDownloadDocumentName = (
  questionnaire?: Questionnaire,
): string => {
  /* TODO: in the future the file naming should be formatted according
      to the language setting */
  const defaultName = "fragebogen"
  const fileNameParts = questionnaire?.fileName.split(".")
  const questionnaireFileName = fileNameParts?.[0]
  const originalExtension = fileNameParts?.[1]
  const extension =
    questionnaire?.hasPositionData && originalExtension
      ? originalExtension
      : "pdf"
  const suffix = "_beantwortet"
  const baseName = questionnaireFileName || defaultName
  const finalName = baseName.endsWith(suffix) ? baseName : baseName + suffix
  return finalName + "." + extension
}
